import React, { Component } from 'react';

import {Link} from 'react-router';
import {observer} from 'mobx-react';


class PhotosPage extends Component {
  render() {
    const albums = this.props.albums;
    return (
      <div>
          {albums.map((album, albumIndex) => (
            <div key={albumIndex} className="grid_16">
              <h2>{album.title}</h2>
              <p>{album.description}</p>
              <div className="items">
                {album.photos.map((photo, photoIndex) => (
                  <a href={photo.imageUrl} key={photoIndex}>
                    <img alt={photo.title} src={photo.thumbnailUrl} title={photo.title} className="thumbnail" style={{width: 200}}/>
                  </a>
                ))}
              </div>
            </div>
          ))}
          <div className="grid_16">
            <br /><br /><br />
            <div className="infobox">
              <Link to="/contact">Contact us for a free, no obligation estimate</Link>
              <p>Need an urgent roof repair? Or maybe just some friendly roofing advice? we're happy to help.</p>
              <br />
              <p className="big">
                <Link to="/contact">Send us an email</Link>
                {' '}
                or call: <span className="phone">07866 432026</span> (Mobile), <span className="phone">01904 793538</span> (Home)<br />
              </p>
            </div>
          </div>
      </div>
    );
  }
}

export default observer(['albums'])(PhotosPage);




/** WEBPACK FOOTER **
 ** ./src/PhotosPage.js
 **/